import { connect } from "react-redux";
import { compose } from "ramda";
import SignIn from "./index";
import { signIn, signInReset } from "../../store/actions/auth";
import { getLoggedUser } from "../../store/selectors/auth";

const mapStateToProps = (state) => ({
  isAuthenticated: getLoggedUser(state).isAuthenticated,
  isAuthenticating: getLoggedUser(state).isAuthenticating,
  signInError: getLoggedUser(state).error,
});

const mapDispatchToProps = {
  onSignIn: signIn,
  onSignInReset: signInReset,
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(SignIn);
